import useAPI from '@core-custom/api/useAPI'
import axios from '@axios'

const { api } = useAPI(axios, {})
export default api
